export let EStatus = /*#__PURE__*/function (EStatus) {
  /** Уже добавлено в сравнение **/
  EStatus["Added"] = "added";
  /** Доступно для добавления в сравнение **/
  EStatus["Available"] = "available";
  /** Недоступно для добавления в сравнение **/
  EStatus["Unavailable"] = "unavailable";
  return EStatus;
}({});